import { Component, Input } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ProviderAllowedIp } from 'src/app/swagger';
import { ProviderService } from 'src/app/swagger/api/provider.service';

@Component({
  selector: 'app-ip-modal-component',
  templateUrl: './ip-modal-component.component.html',
  styleUrls: ['./ip-modal-component.component.scss'],
})
export class IpModalComponentComponent {
  @Input() allowedIps: ProviderAllowedIp[] = [];
  @Input() providerId: number;
  @Input() isReadOnly: boolean = false;

  newIpAddress: string = '';
  loading: boolean = false;

  constructor(
    private modalController: ModalController,
    private toastController: ToastController,
    private providerManager: ProviderService,
    private translate: TranslateService
  ) {}

  async addIp() {
    const ip = this.newIpAddress.trim();
    if (!ip) {
      this.showToast('IP cannot be empty.');
      return;
    }

    try {
      this.loading = true;
      await this.providerManager.providerNewIpPost({ip: ip, providerId: this.providerId}).toPromise();
      this.newIpAddress = '';
      this.showToast('IP added successfully.');
      await this.reloadIpsFromBackend();
    } catch (err) {
      console.error('Error adding IP', err);
      this.showToast('Failed to add IP.');
    } finally {
      this.loading = false;
    }
  }

  async removeIp(ipId: number, index: number) {
    if (this.isReadOnly) return;

    try {
      this.loading = true;
      await this.providerManager.providerDeleteIpIpIdDelete(ipId).toPromise();
      this.showToast('IP removed.');
      await this.reloadIpsFromBackend();
    } catch (err) {
      console.error('Error deleting IP', err);
      this.showToast('Failed to remove IP.');
    } finally {
      this.loading = false;
    }
  }

  async editIp(ip: ProviderAllowedIp, index: number) {
    const ipAddress = ip.ipAddress.trim();
    if (!ipAddress) {
      this.showToast('IP address cannot be empty.');
      return;
    }

    try {
      this.loading = true;
      await this.providerManager.providerEditIpIpIdPost({ ip: ipAddress }, ip.id).toPromise();
      this.showToast('IP updated successfully.');
      await this.reloadIpsFromBackend();
    } catch (err) {
      console.error('Error updating IP', err);
      this.showToast('Failed to update IP.');
    } finally {
      this.loading = false;
    }
  }

  dismissModal() {
    this.modalController.dismiss(
      { updated: true },
      'confirm' 
    );
  }

  private async showToast(message: string) {
    const toast = await this.toastController.create({
      message: this.translate.instant(message),
      duration: 2000,
      position: 'bottom',
    });
    toast.present();
  }

  private reloadIpsFromBackend(): void {
    this.providerManager.providerGetIpsProviderIdGet(this.providerId).subscribe({
      next: (updatedIps) => {
        this.allowedIps = updatedIps.ips as ProviderAllowedIp[];
      },
      error: (err) => {
        console.error('Failed to reload IPs', err);
        this.showToast('Failed to reload IP list.');
      }
    });
  }
}